const clients = {
  permissionSource: 'api::client.client',
  creationTitle: 'Create Client',
  creationEndPoint: '/clients',
  detailTitle: 'Client: :title',
  detailEndPoint:
    '/clients/:id?populate[0]=logo&populate[1]=tel&populate[2]=fax&populate[3]=whatsapp&populate[4]=address&populate[5]=address.region&populate[6]=parent_company&populate[7]=subsidiary&populate[8]=client_type&populate[9]=client_channel&populate[10]=contact_people&populate[11]=sales_quotations&populate[12]=sales_invoices&populate[13]=sales_receipts',
  detail: [
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          isLayout: true,
          layoutPattern: '1',
          children: [
            {
              label: 'Code',
              value: 'code',
              tag: 'input',
              type: 'text',
              placeholder: 'Client Code',
              required: true,
            },
            {
              label: 'Name',
              value: 'name',
              tag: 'input',
              type: 'text',
              placeholder: 'Client Name',
              required: true,
            },
            {
              label: 'Email',
              value: 'email',
              tag: 'input',
              type: 'email',
              placeholder: 'Client Email',
            },
            {
              label: 'Blacklisted',
              value: 'blacklisted',
              tag: 'switch',
            },
            {
              label: 'Website',
              value: 'website',
              tag: 'input',
              type: 'text',
              placeholder: 'Client Website URL',
            },
            {
              label: 'Parent Company',
              value: 'parent_company',
              tag: 'single-select',
              dataSourceUrl: '/clients',
              dataLabel: 'name',
            },
            {
              label: 'Subsidiaries',
              value: 'subsidiary',
              tag: 'multi-select',
              dataSourceUrl: '/clients',
              dataLabel: 'name',
            },
            {
              label: 'BR Number',
              value: 'br_number',
              tag: 'input',
              type: 'text',
              placeholder: 'XXXXXXXX-XXX-XX-XX-X',
            },
            {
              label: 'Number of Staff',
              value: 'number_of_staff',
              tag: 'input',
              type: 'number',
            },
            {
              label: 'Date of Establishment',
              value: 'date_of_establishment',
              tag: 'date-picker',
            },
          ],
        },
        {
          isLayout: true,
          layoutPattern: '1',
          children: [
            {
              label: 'Logo',
              value: 'logo',
              tag: 'media',
              acceptFile: 'image/*',
            },
            {
              isLayout: true,
              layoutPattern: '1-1-2',
              children: [
                {
                  label: 'Telephone',
                  value: 'tel.country_code',
                  placeholder: '+852',
                  tag: 'input',
                  type: 'number',
                },
                {
                  label: '',
                  value: 'tel.area_code',
                  placeholder: '123',
                  tag: 'input',
                  type: 'number',
                },
                {
                  label: '',
                  value: 'tel.contact_number',
                  placeholder: '2121 1323',
                  tag: 'input',
                  type: 'number',
                },
              ],
            },
            {
              isLayout: true,
              layoutPattern: '1-1-2',
              children: [
                {
                  label: 'Mobile',
                  value: 'mobile.country_code',
                  placeholder: '+852',
                  tag: 'input',
                  type: 'number',
                },
                {
                  label: '',
                  value: 'mobile.area_code',
                  placeholder: '123',
                  tag: 'input',
                  type: 'number',
                },
                {
                  label: '',
                  value: 'mobile.contact_number',
                  placeholder: '2121 1323',
                  tag: 'input',
                  type: 'number',
                },
              ],
            },
            {
              isLayout: true,
              layoutPattern: '1-1-2',
              children: [
                {
                  label: 'Fax',
                  value: 'fax.country_code',
                  placeholder: '+852',
                  tag: 'input',
                  type: 'number',
                },
                {
                  label: '',
                  value: 'fax.area_code',
                  placeholder: '123',
                  tag: 'input',
                  type: 'number',
                },
                {
                  label: '',
                  value: 'fax.contact_number',
                  placeholder: '2121 1323',
                  tag: 'input',
                  type: 'number',
                },
              ],
            },
            {
              isLayout: true,
              layoutPattern: '1-1-2',
              children: [
                {
                  label: 'WhatsApp',
                  value: 'whatsapp.country_code',
                  placeholder: '+852',
                  tag: 'input',
                  type: 'number',
                },
                {
                  label: '',
                  value: 'whatsapp.area_code',
                  placeholder: '123',
                  tag: 'input',
                  type: 'number',
                },
                {
                  label: '',
                  value: 'whatsapp.contact_number',
                  placeholder: '2121 1323',
                  tag: 'input',
                  type: 'number',
                },
              ],
            },
            {
              label: 'Client Type',
              value: 'client_type',
              tag: 'single-select',
              dataSourceUrl: '/client-types',
              dataLabel: 'title',
            },
            {
              label: 'Client Channel',
              value: 'client_channel',
              tag: 'single-select',
              dataSourceUrl: '/client-channels',
              dataLabel: 'title',
            },
            {
              label: 'Contact People',
              value: 'contact_people',
              tag: 'multi-select',
              dataSourceUrl: '/contact-people',
              dataLabel: 'name',
            },
          ],
        },
      ],
    },
    {
      label: 'Address',
      value: 'address.address_line_1',
      placeholder: 'Address Line 1',
      tag: 'input',
      type: 'text',
    },
    {
      value: 'address.address_line_2',
      placeholder: 'Address Line 2',
      tag: 'input',
      type: 'text',
    },
    {
      value: 'address.address_line_3',
      placeholder: 'Address Line 3',
      tag: 'input',
      type: 'text',
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Country',
          value: 'address.country',
          tag: 'input',
          type: 'text',
        },
        {
          label: 'Region',
          value: 'address.region',
          tag: 'single-select',
          dataSourceUrl: '/regions',
          dataLabel: 'name',
        },
        {
          label: 'Zip',
          value: 'address.zip',
          tag: 'input',
          type: 'text',
        },
      ],
    },
    {
      label: 'Purchase Related Remark',
      value: 'purchase_related_remark',
      tag: 'richTextarea',
      placeholder: 'Purchase Related Remark (eg. Device S/N)',
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Gender',
          value: 'individual_gender',
          tag: 'single-enum-select',
          dataSourceUrl: '/content-type-builder/content-types/api::client.client',
          dataLabel: 'individual_gender',
        },
        {
          label: 'Date of Birth',
          value: 'individual_date_of_birth',
          tag: 'date-picker',
        },
        {
          label: 'Occupation',
          value: 'individual_occupation',
          tag: 'input',
          type: 'text',
          placeholder: 'Occupation',
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Credit',
          value: 'credit',
          placeholder: 'Credit amount',
          tag: 'input',
          type: 'number',
        },
        {
          label: 'Paid',
          value: 'paid',
          placeholder: 'Paid amount',
          tag: 'input',
          type: 'number',
        },
        {
          label: 'Advance',
          value: 'advance',
          placeholder: 'Advance amount',
          tag: 'input',
          type: 'number',
        },
      ],
    },
    {
      label: 'Sales Quotations',
      value: 'sales_quotations',
      tag: 'static-multi-select',
      redirectRoute: '/sales-quotations/:id',
      dataLabel: 'code',
    },
    {
      label: 'Sales Invoices',
      value: 'sales_invoices',
      tag: 'static-multi-select',
      redirectRoute: '/sales-invoices/:id',
      dataLabel: 'code',
    },
    {
      label: 'Sales Receipts',
      value: 'sales_receipts',
      tag: 'static-multi-select',
      redirectRoute: '/sales-receipts/:id',
      dataLabel: 'code',
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Create Date / Time',
          value: 'custom_created_at',
          tag: 'static-text',
        },
        {
          label: 'Publish Date / Time',
          value: 'publishedAt',
          tag: 'static-text',
        },
        {
          label: 'Update Date / Time',
          value: 'custom_updated_at',
          tag: 'static-text',
        },
      ],
    },
  ],
}
export default clients
